import React, { Component } from 'react'

export default class Ci extends Component {
    render() {
        return (
            <main className="page-main-pal container">
                <div className="alocolumns clearfix">
                    <div className="column main">
                    <div className="product-view">
                        <div className="product-essential">
                        <div className="row">
                            <div className="product media product-img-box clearfix col-md-5 col-sm-5 col-xs-12">
                            <div className="gallery-placeholder _block-content-loading" data-gallery-role="gallery-placeholder">
                                <img alt="main product" className="gallery-placeholder__image" src="https://zollwebstore.com/media/catalog/product/cache/467759fb9b775470ce656bfad32dcb43/8/9/8900-0810-01_a.jpg" />
                            </div>
                            </div>
                            <div className="product-info-main product-shop col-md-7 col-sm-7 col-xs-12">
                            <div className="product-info-price">
                                <div className="page-title-wrapper">
                                    {/* ganti judul product detail */}
                                <h1 className="page-title">
                                    <span className="base" data-ui-id="page-title-wrapper">ZOLL Pedi Padz II Electrode</span>
                                </h1>
                                </div>
                                <span data-role="amhideprice-hide-button" id="amhideprice-product-id-314-1040" style={{display: 'none !important'}} />
                            </div>
                            <div className="product attribute overview">
                                {/* ganti product description product detail */}
                                <div className="value" itemProp="description">
                                    <p>ZOLL Pedi Padz II Electrode</p>
                                    <p>
                                    ZOLL Pedi Padz II Electrodes dirancang khusus untuk memberikan perawatan darurat yang aman dan efektif bagi pasien anak. Elektroda ini kompatibel dengan defibrillator ZOLL, memastikan respons cepat dan tepat dalam situasi henti jantung mendadak pada anak-anak.
                                    </p>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>    
                    </div>
                </div>
            </main>
        )
    }
}
